import { Text } from '@mantine/core';
import * as React from 'react';
import { Show } from '../../../../react-commons/components/control-flow/Show';

export const NothingSelectedComponent= ({ instruction, onlyInstruction }: { instruction?: string, onlyInstruction?: boolean }) => {
    return (
        <div
            style={{
                display: 'flex',
                overflowY: 'hidden',
                width: '100%',
                height: '100%',
            }}
        >
            <div
                style={{
                    textAlign: 'center',
                    width: '100%',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                }}
            >
                <Show when={!onlyInstruction}>
                    <Text fs={'italic'}>{'Nothing is selected'}</Text>
                </Show>
                <Show when={instruction}>
                    <br />
                    <Text fs={'italic'}>{instruction}</Text>
                </Show>
            </div>
        </div>
    );
};


